import { useHistory } from "react-router-dom"
import { useAllOrders } from "../../hooks/orders"
import { localizeDateWithDay } from "../../utils"

import { Button, Link } from "@chakra-ui/react"
import { CheckCircleIcon, ExternalLinkIcon } from "@chakra-ui/icons"

import DataTable from "../Common/DataTable"
import DeleteButton from "../Common/DeleteButton"

const LinkList = ({
  items,
  selected,
  setSelected,
  toggleActive,
  removeLink,
}) => {
  let history = useHistory()
  const { orders } = useAllOrders()

  return (
    <DataTable
      rows={items}
      columns={{
        active: {
          label: "Attivo",
          textAlign: "center",
          sort: false,
          render: (item) => (
            <CheckCircleIcon
              w={4}
              h={4}
              color={item.active ? "green.500" : "gray.200"}
              cursor="pointer"
              onClick={(e) => {
                e.stopPropagation()
                toggleActive(item)
              }}
            />
          ),
        },
        startDate: {
          label: "Apertura",
          render: (item) =>
            item.startDate && localizeDateWithDay(item.startDate),
        },
        endDate: {
          label: "Chiusura",
          render: (item) => item.endDate && localizeDateWithDay(item.endDate),
        },
        name: {
          label: "Nome",
          expand: true,
        },
        /*selectedProducts: {
          label: "Prodotti",
          render: (item) => item.selectedProducts?.length,
        },*/
        numOrders: {
          label: "Ordini",
          render: (item) =>
            orders.filter((order) => order.linkId === item.id)?.length,
        },
        openLinkAction: {
          label: "",
          sort: false,
          textAlign: "center",
          render: (item) => (
            <Button
              as={Link}
              size="sm"
              href={`/${item.id}`}
              isExternal
              colorScheme="teal"
              onClick={(e) => e.stopPropagation()}
            >
              Apri Link
            </Button>
          ),
        },
        editAction: {
          label: "",
          sort: false,
          textAlign: "center",
          render: (item) => (
            <Button
              size="sm"
              colorScheme="green"
              onClick={(e) => {
                e.stopPropagation()
                setSelected(item)
              }}
            >
              Modifica
            </Button>
          ),
        },
        deleteAction: {
          label: "",
          sort: false,
          textAlign: "center",
          render: (item) => (
            <DeleteButton
              variant="textButton"
              onClick={() => removeLink(item.id)}
            />
          ),
        },
      }}
      selected={selected}
      setSelected={setSelected}
      onRowClick={(item) => history.push(`/admin/ordini/${item.id}`)}
    />
  )
}

export default LinkList
